import { createContext } from 'react';
import type { HomeUtils, StarterTodoItemsList } from 'types/home.types';

export const HomePageContext = createContext<
  HomeUtils & {
    state: Record<string, any>;
    starterTodoList: StarterTodoItemsList;
    isTodoDone: (key: string) => boolean;
  }
>({} as any);
